export const nullBooleanDropdown = [
                                    {'value': null, 'text': null},
                                    {'value': true, 'text': "Yes"},
                                    {'value': false, 'text': "No"}
                                ]


// WEBPACK FOOTER //
// ./src/pages/common.js